'use strict';
var AssignController = (function () {
    function AssignController($stateParams) {
        this.$stateParams = $stateParams;
        //console.info('StateParams ', this.$stateParams);
        if (this.$stateParams.id === 'myqueue' || this.$stateParams.id === 'teamqueue') {
            this.isReassign = true;
        }
        else {
            this.isReassign = false;
        }
        //console.info('AssignComponent created', this.isReassign);
    }
    AssignController.$inject = ['$stateParams'];
    return AssignController;
}());
var AssignComponent = (function () {
    function AssignComponent() {
        this.bindings = { vm: '<' };
        this.templateUrl = 'assign.html';
        this.controller = AssignController;
    }
    return AssignComponent;
}());
angular
    .module('application')
    .component('assignSection', new AssignComponent());

//# sourceMappingURL=assign.component.js.map
